import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@rudi/api/react';
import type { UptimeReport } from '@cortex/uptime-report';

export type {
  CheckResult,
  DayReport,
  Environment,
  Incident,
  TargetReport,
  TargetStatus,
  UptimeReport,
} from '@cortex/uptime-report';

export interface CheckerView {
  id: string;
  label: string;
  /** `waiting` means the checker has not reported since the backend started. */
  status: 'reporting' | 'unreachable' | 'waiting';
  receivedAt: string | null;
  report: UptimeReport | null;
}

export interface UptimeResponse {
  checkers: CheckerView[];
}

export const UPTIME_REFRESH_MS = 60_000;

export function useUptime() {
  const api = useApiClient();
  return useQuery({
    queryKey: ['uptime'],
    queryFn: async () => (await api.get<UptimeResponse>('/uptime')).data,
    refetchInterval: UPTIME_REFRESH_MS,
  });
}
